module.exports = __webpack_public_path__ + "img/IMG_1149_L_BlackMatted.67625093.jpg";